const userInitialState = {
  token: null,
  data: {
    type: "Customer"
  },
  authStatus: false
};
export default userInitialState;



// WEBPACK FOOTER //
// ./src/store/initialStates/userInitialState.js